var _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLine8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 500,
    viewBox: "0 0 1 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 2.18557e-8,
    x2: 0.499978,
    y2: 500,
    stroke: "black",
    strokeOpacity: 0.12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine8);
export default __webpack_public_path__ + "static/media/line-8.96537a1fd6912a4236d059e1eccce5f9.svg";
export { ForwardRef as ReactComponent };